import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'alertMarkersVisible'
const DEFAULT_VISIBLE = true

function readFromStorage(): boolean {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (raw === null) return DEFAULT_VISIBLE
    return raw === 'true'
  } catch {
    return DEFAULT_VISIBLE
  }
}

export function useAlertMarkersVisibility(): {
  visible: boolean
  toggle: () => void
  setVisible: (next: boolean) => void
} {
  const [visible, setVisibleState] = useState<boolean>(() => readFromStorage())

  useEffect(() => {
    function onStorage(event: StorageEvent) {
      if (event.key === STORAGE_KEY) {
        setVisibleState(readFromStorage())
      }
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  const setVisible = useCallback((next: boolean) => {
    setVisibleState(next)
    try {
      window.localStorage.setItem(STORAGE_KEY, String(next))
    } catch {
      // non-fatal: fall back to in-memory state only
    }
  }, [])

  const toggle = useCallback(() => setVisible(!visible), [visible, setVisible])

  return { visible, toggle, setVisible }
}
